import axios from "axios";
import qs from "qs";
import { Documentation, defaultDocumentation } from "../types/documentation";
import { toSnakeCase } from "../utils/objectHelper";

export const DocumentationTranport = {
    getDocument: async (params: any): Promise<Documentation> => {
        const { data } = await axios.get<Documentation | null>(
            `/documentation${params ? `?${qs.stringify(params)}` : ""}`
        );
        if (!data) {
            return defaultDocumentation;
        }
        return data;
    },
    save: async (documentation: Documentation): Promise<Documentation> => {
        const response = await axios.request<Documentation>({
            method: documentation.id ? "put" : "post",
            url: documentation.id ? `/documentation/${documentation.id}` : "/documentation",
            data: toSnakeCase(documentation),
        });

        return response.data;
    },
};
